import { createRouter, createWebHashHistory } from "vue-router";
import constant from "@/constant";
import Layout from "@/layout/Layout";
import Cookies from "js-cookie";
const routes = [
  {
    path: "/",
    name: "Login",
    id: "1",
    meta: { title: "用户登录", requireAuth: false },
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/main",
    id: "2",
    component: Layout,
    name: "工作台",
    icon: "el-icon-s-home",
    meta: { title: constant.title, requireAuth: true },
    redirect: "/home",
    children: [
      {
        path: "/home",
        id: "3",
        name: "工作台",
        icon: "el-icon-s-home",
        meta: { title: "工作台", requireAuth: true },
        component: () => import("@/views/Home.vue"),
      },
    ],
  },
  // {
  //   path: "/main2",
  //   id: "11",
  //   component: Layout,
  //   name: "个人资料",
  //   meta: { title: constant.title, requireAuth: true },
  //   redirect: "/personinfo",
  //   children: [
  //     {
  //       path: "/personinfo",
  //       id: "12",
  //       name: "个人资料",
  //       icon: "el-icon-user",
  //       meta: { title: "个人资料", requireAuth: true },
  //       component: () => import("@/views/PersonInfo.vue"),
  //     },
  //   ],
  // },
  {
    path: "/order",
    id: "46",
    name: "订单管理",
    component: Layout,
    icon: "el-icon-document-copy",
    meta: { title: constant.title, requireAuth: true },
    children: [
      {
        path: "/order",
        id: "47",
        name: "订单管理 ",
        meta: { title: "订单管理 ", requireAuth: true, show: true },
        component: () => import("@/views/Order.vue"),
      },
    ],
  },
  {
    path: "/finance",
    id: "54",
    name: "财务管理",
    component: Layout,
    icon: "el-icon-coin",
    meta: { title: constant.title, requireAuth: true },
    children: [
      {
        path: "/bill",
        id: "55",
        name: "交易流水",
        meta: { title: "交易流水", requireAuth: true, show: true },
        component: () => import("@/views/Bill.vue"),
      },
      {
        path: "/cashout",
        id: "57",
        name: "提现管理",
        meta: { title: "提现管理", requireAuth: true, show: true },
        component: () => import("@/views/Cashout.vue"),
      },
      {
        path: "/settle",
        id: "58",
        name: "结算管理",
        meta: { title: "结算管理", requireAuth: true, show: true },
        component: () => import("@/views/Settle.vue"),
      },
      {
        path: "/rechargedetail",
        id: "60",
        name: "充值管理",
        meta: { title: "充值管理", requireAuth: true, show: true },
        component: () => import("@/views/rechargedetail.vue"),
      },
      {
        path: "/invoice",
        id: "63",
        name: "申请发票",
        meta: { title: "申请发票", requireAuth: true, show: true },
        component: () => import("@/views/Invoice.vue"),
      },
    ],
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = constant.title;
  }
  let token = Cookies.get("token");
  if (to.name != "Login") {
    if (!token || token == "undefined") {
      //没有登录过
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
